import axios from "axios";
import { ICreateBookingApiParams } from "../types";
import { IGetTotalToBePaidReturn } from "./getTotalToBePaid";
import { IBooking } from "../../types";

interface IFullEditParams extends ICreateBookingApiParams {
    id: string
    total: IGetTotalToBePaidReturn
}

interface IBookReturn {
    code: string;
    data: IBooking;
}

export const fullEditBooking = async ({ id, ...params }: IFullEditParams): Promise<IBookReturn> => {
    const response = axios.post(`/booking/book/${id}/fullEdit`, params);
    return (await response).data;
};
